import { FaArrowRight } from "react-icons/fa";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import Trame from "../assets/img/TrameFine.webp";
import RealPeinture from "../assets/img/Real-peinture.webp";
import RealPeinture2 from "../assets/img/Real-peinture-2.webp";
import Carousel2 from "../components/Carousel2";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

export default function Realisations() {
  return (
    <div className="realisations">
      <Helmet>
        <title>
          Réalisations – Peinture et décoration à Vannes | Clara Décor
        </title>
        <meta
          name="description"
          content="Découvrez les projets réalisés par Clara Décor à Vannes et dans le Morbihan : peinture intérieure et extérieure, enduits décoratifs, ravalement de façades et finitions soignées."
        />
        <link rel="canonical" href="https://claradecor.fr/realisations" />
        <meta
          property="og:title"
          content="Réalisations – Clara Décor, peinture et décoration à Vannes"
        />
        <meta
          property="og:description"
          content="Galerie de projets : peinture murs et plafonds, enduits décoratifs, boiseries et ravalement de façades réalisés avec soin à Vannes et alentours."
        />
        <meta property="og:url" content="https://claradecor.fr/realisations" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://claradecor.fr/images/og-realisations.jpg"
        />
        <meta property="og:locale" content="fr_FR" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* JSON-LD pour les réalisations */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Réalisations – Clara Décor",
      "url": "https://claradecor.fr/realisations",
      "description": "Galerie des projets réalisés par Clara Décor : peinture intérieure et extérieure, ravalement de façades, enduits décoratifs et revêtements muraux et sols à Vannes et dans le Morbihan.",
      "hasPart": [
        {
          "@type": "CreativeWork",
          "name": "Peinture intérieure",
          "url": "https://claradecor.fr/realisations#peinture-interieure",
          "description": "Projets de peinture intérieure : murs, plafonds, boiseries avec finitions soignées et harmonies de couleurs sur-mesure."
        },
        {
          "@type": "CreativeWork",
          "name": "Décoration & enduits décoratifs",
          "url": "https://claradecor.fr/realisations#decoration",
          "description": "Projets décoratifs avec enduits raffinés et choix de textures et matières adaptés à chaque espace."
        },
        {
          "@type": "CreativeWork",
          "name": "Peinture extérieure & ravalement de façades",
          "url": "https://claradecor.fr/realisations#ravalement",
          "description": "Ravalement de façades et peinture extérieure avec protection durable et finition."
        }
      ]
    }
    `}
        </script>
      </Helmet>

      <Navbar />
      <header>
        <div className="header-left">
          <h1>Réalisations</h1>
          <p>
            Chaque projet est conçu comme{" "}
            <span className="color1">une création unique</span>, où l’excellence
            artisanale se mêle à la précision des finitions. Avec rigueur et
            minutie, <span className="color1">je sublime vos espaces</span>,
            qu’il s’agisse de rénovations ou d’aménagements, pour révéler leur
            élégance et leur singularité avec un résultat à la fois{" "}
            <span className="color1">raffiné et durable</span>.
          </p>
          <div className="header-btn">
            <button
              className="btn-primary"
              onClick={() => {
                const el = document.getElementById("realisations");
                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }
              }}
              type="button"
            >
              Découvrir mes realisations{" "}
              <span className="arrow">
                <FaArrowRight />
              </span>
            </button>
          </div>
        </div>
      </header>
      <body>
        <img src={Trame} className="trame" alt="image de trame Clara Décors" />

        <div className="realisations-title" id="realisations">
          <h2>Mes Réalisations</h2>
          <p>
            Forte de plus de <span className="color1">10 ans d'expérience</span>
            , je vous accompagne dans tous vos projets de décoration, avec un{" "}
            <span className="color1">service personnalisé</span> et un souci du
            détail à chaque étape.
          </p>
        </div>
        <Carousel2 />
        <div className="realisations-btn">
          <Link to={"/services"} className="btn-primary">
            Découvrir mes services{" "}
            <span className="arrow">
              <FaArrowRight />
            </span>
          </Link>
          <Link to={"/contact"} className="btn-secondary">
            Prendre contact
          </Link>
        </div>
        <div className="realisations-peinture">
          <div className="realisations-peinture-left">
            <img src={RealPeinture} alt="Réalisation Peinture" />
          </div>
          <div className="realisations-peinture-right">
            <h2>Peinture</h2>
            <h3>Un travail soigné & à votre écoute</h3>
            <p>
              Chaque projet débute par une analyse approfondie de votre espace
              et de vos besoins. Après ce rendez-vous initial,{" "}
              <span className="color1">
                je définis avec vous les teintes et finitions
              </span>{" "}
              les plus adaptées et{" "}
              <span className="color1">
                vous accompagne tout au long de la réalisation
              </span>
              . Mon exigence se traduit par un travail précis et soigné, avec
              des finitions impeccables qui révèlent l’élégance et{" "}
              <span className="color1">la personnalité de vos intérieurs</span>.
            </p>
          </div>
        </div>
        <div className="realisations-decoration">
          <div className="realisations-decoration-left">
            <h2>Décoration</h2>
            <h3>Un travail soigné & à votre écoute</h3>
            <p>
              Les projets de décoration commencent par un échange détaillé pour
              <span className="color1"> cerner vos envies</span> et comprendre
              l’usage et l’ambiance souhaitée pour chaque espace. Selon le
              projet,{" "}
              <span className="color1">un mood board peut être élaboré</span>{" "}
              pour visualiser les harmonies de couleurs, matières et textures.
              Je vous guide ensuite dans le choix final et supervise chaque
              étape, afin que chaque détail contribue à{" "}
              <span className="color1">
                une décoration raffinée, harmonieuse et parfaitement adaptée à
                votre intérieur
              </span>
              .
            </p>
          </div>
          <div className="realisations-decoration-right">
            <img src={RealPeinture2} alt="Réalisation Peinture" />
          </div>
        </div>
        <div className="suggestions">
          <h2>Des questions ?</h2>
          <p className="suggestions-text">
            Chaque projet est unique et il est normal d'avoir des{" "}
            <span className="color1">interrogations spécifiques.</span> Si vous
            ne trouvez pas réponse à vos questions, n'hésitez pas à me contacter
            via le formulaire dédié, je vous répondrais dans les plus brefs
            délais, avec toute l'attention que mérite{" "}
            <span className="color1">votre projet.</span>
          </p>
          <Link to={"/contact"} className="btn-secondary">
            Prendre contact
          </Link>
        </div>
        <div className="prefooter"></div>
      </body>
      <Footer />
    </div>
  );
}
